module.exports = __webpack_public_path__ + "static/media/google-podcast.97a3bb6f.svg";